export enum AssistanceAccidentReplacementCarOption {
    ASSISTANCE_ACCIDENT_REPLACEMENT_CAR_NO = 'ASSISTANCE_ACCIDENT_REPLACEMENT_CAR_NO',
}
